(function(){
  if(window.__DB_STICKY_FORM_JS) return; window.__DB_STICKY_FORM_JS=1;
  var INST=window.__DB_STICKY_INSTANCES||(window.__DB_STICKY_INSTANCES={});
  function j(el){try{return JSON.parse(el.textContent||'{}')}catch(e){return null}}
  function qa(sel,root){return Array.prototype.slice.call((root||document).querySelectorAll(sel))}
  
  function initAll(){
    var cfgEls=qa('script[type="application/json"][data-sticky-config]'); 
    if(!cfgEls.length) return;
    
    cfgEls.forEach(function(cfgEl){
      var cfg=j(cfgEl); 
      if(!cfg) return;
      
      var key=cfg.key||cfg.formId||'db-sticky';
      if(INST[key]&&typeof INST[key]==='function'){try{INST[key]()}catch(e){} delete INST[key]}
      
      var sticky=document.querySelector('product-sticky-form'); 
      if(!sticky) return;
      
      var mainForm = document.getElementById(cfg.formId) || document.querySelector('.product-form form, form[action*="/cart/add"]'); 
      if(!mainForm) return; 
      
      var cleanup=[],passive={passive:true};
      function on(el,ev,fn,opt){if(!el) return; el.addEventListener(ev,fn,opt); cleanup.push(function(){try{el.removeEventListener(ev,fn,opt)}catch(e){}})}
      function done(){for(var i=0;i<cleanup.length;i++) try{cleanup[i]()}catch(e){} cleanup=[]}
      INST[key]=done;

      var POS=sticky.getAttribute('data-db-pos')||cfg.pos||'bottom_all';
      var mqlDesk=window.matchMedia('(min-width: 1000px)');
      function isTopNow(){return POS==='top_all'||(POS==='top_desktop_bottom_mobile'&&mqlDesk.matches)}
      var hdr=document.querySelector('#shopify-section-header, .shopify-section--header, header');
      function getHdrOff(){var o=0;try{o=typeof getStickyHeaderOffset==='function'?(+getStickyHeaderOffset()||0):0}catch(e){}if(!o){var r=getComputedStyle(document.documentElement),v=(r.getPropertyValue('--sticky-header-height')||r.getPropertyValue('--header-height')||'').trim();o=parseFloat(v)||0}if(!o&&hdr)o=Math.round(hdr.getBoundingClientRect().height)||0;return o}
      function applyTopNow(){if(!isTopNow()){sticky.style.removeProperty('top');sticky.style.removeProperty('bottom');sticky.style.removeProperty('z-index');return}var o=getHdrOff();o?sticky.style.top=o+'px':sticky.style.removeProperty('top');sticky.style.bottom='auto';if(hdr){var z=parseInt(getComputedStyle(hdr).zIndex,10);!isNaN(z)?sticky.style.zIndex=String(z-1):sticky.style.removeProperty('z-index')}}

      var ready=false;
      function ensureReady(){if(ready) return; ready=true; initLogic()}

      function setupVisibility(){
        function getRaw(){
          var v=null;
          if(mqlDesk.matches){
            v = sticky.dataset.offsetDesktop;
            if((v==null || v==='') && cfg && cfg.offsetDesktop!=null) v = cfg.offsetDesktop;
            if(v==null || v==='') v = sticky.dataset.offset;
            if((v==null || v==='') && cfg && cfg.offset!=null) v = cfg.offset;
          }else{
            v = sticky.dataset.offset;
            if((v==null || v==='') && cfg && cfg.offsetMobile!=null) v = cfg.offsetMobile;
            if((v==null || v==='') && cfg && cfg.offset!=null) v = cfg.offset;
          }
          if(v==null || v==='') v = 30;
          v = parseFloat(v);
          if(isNaN(v)) v = 30;
          return v;
        }

        var raw=getRaw();
        var mode='threshold'; if(raw<=0) mode='never'; else if(raw>=95) mode='always';
        var thr=(mode==='threshold')?((100-raw)/100):0;

        var hideNearOn=!!(cfg && cfg.hideNearForm);
        var hideNearMode=(cfg && cfg.hideNearMode) ? String(cfg.hideNearMode) : 'resume_below';
        var nearInView=false, nearLocked=false, nearIO=null;
        var nearTarget=null;

        function findBuyTarget(){
          return mainForm.querySelector('button[type="submit"],button[name="add"],.product-form__add-button,[data-action="add-to-cart"]');
        }

        function computeInView(el){
          if(!el) return false;
          var r=el.getBoundingClientRect();
          return r.bottom>0 && r.top<window.innerHeight;
        }

        function setNear(v){
          if(v && hideNearMode==='hide_forever') nearLocked=true;
          nearInView=!!v;
        }

        function toggle(){
          var y=window.scrollY,vb=y+window.innerHeight,showPoint=(document.body.scrollHeight-window.innerHeight)*thr,show;
          if(mode==='never') show=false; else if(mode==='always') show=true; else show=y>=showPoint;
          
          var realFooter = document.querySelector('.shopify-section--footer') || document.querySelector('footer.footer');
          if(realFooter && realFooter.offsetHeight > 0) {
            var fRect = realFooter.getBoundingClientRect();
            if(fRect.top <= window.innerHeight + 20) {
              show = false;
            }
          }
          
          if(vb >= document.documentElement.scrollHeight - 30) {
            show = false;
          }

          if(hideNearOn){
            if(nearLocked) show=false;
            else{
              if(!nearTarget || !nearTarget.isConnected) nearTarget=findBuyTarget();
              if(nearTarget){
                var r=nearTarget.getBoundingClientRect(),top=r.top+y,bot=r.bottom+y;
                nearInView=(r.bottom>0 && r.top<window.innerHeight);
                if(nearInView) show=false;
                else if(hideNearMode==='resume_above' && y>=bot) show=false;
              }
            }
          }

          if (show) {
            sticky.removeAttribute('hidden');
            sticky.style.opacity = '1';
            sticky.style.visibility = 'visible';
            sticky.style.transform = 'translateY(0)';
            sticky.style.pointerEvents = 'auto';
            ensureReady();
          } else {
            sticky.setAttribute('hidden', 'true');
            sticky.style.opacity = '0';
            sticky.style.visibility = 'hidden';
            sticky.style.transform = POS === 'top_all' ? 'translateY(-100%)' : 'translateY(100%)';
            sticky.style.pointerEvents = 'none';
          }
        }

        function setupHideNear(){
          if(!hideNearOn) return;
          var target=findBuyTarget();
          if(!target) return;
          setNear(computeInView(target));
          nearTarget=target;

          if('IntersectionObserver' in window){
            nearIO=new IntersectionObserver(function(entries){
              for(var i=0;i<entries.length;i++){
                var e=entries[i];
                if(e && e.target===target){
                  setNear(!!e.isIntersecting);
                  break;
                }
              }
              toggle();
              if(nearLocked && nearIO){try{nearIO.disconnect()}catch(e){} nearIO=null;}
            },{root:null,threshold:0.15});
            try{nearIO.observe(target)}catch(e){}
            cleanup.push(function(){try{nearIO&&nearIO.disconnect()}catch(e){} nearIO=null;});
          }else{
            function refreshNear(){
              if(nearLocked) return;
              if(!target || !target.isConnected){target=findBuyTarget(); if(!target) return;}
              setNear(computeInView(target));
              toggle();
            }
            on(window,'scroll',refreshNear,passive);
            on(window,'resize',refreshNear,passive);
            refreshNear();
          }
        }

        function refresh(){ toggle() }

        setupHideNear();
        refresh();
        on(window,'resize',refresh,passive);
        on(window,'scroll',toggle,passive);
        setTimeout(toggle, 500);
      }
      
      function initLogic(){
        var LANG=document.documentElement.lang||cfg.locale||"en-US";
        var CUR=cfg.currencyIso||"USD";
        var UNAVAIL=cfg.unavail||"Sold out";
        var HIDE_SEL_PRICE=!!cfg.hideSelectedPrice;
        var USE_PH=!!cfg.usePlaceholder;
        var HIDE_SOLD_OUT=!!cfg.hideSoldOut;
        var stickyUseCombo=!!cfg.stickyUseCombo;
        var showPrices=!HIDE_SEL_PRICE;

        var NF=null;
        try{NF=new Intl.NumberFormat(LANG,{style:"currency",currency:CUR,minimumFractionDigits:2,maximumFractionDigits:2})}catch(e){NF=null}
        function fmt(c){
          var v=Number(c)/100;
          try{if(NF){var s=NF.format(v); s=s.replace(/\s+€/,"€"); return s;}}catch(e){}
          try{if(window.Shopify&&Shopify.formatMoney){var tpl=cfg.moneyWithCurrencyFormat||""; tpl=tpl.replace(/amount(?:_no_decimals)?(?:_with_[a-z]+_separator)?/g,"amount_with_comma_separator"); return Shopify.formatMoney(c,tpl).replace(/\s+€/,"€");}}catch(e){}
          return v.toFixed(2).replace(".",",")+(cfg.currencySymbol||"");
        }

        if(cfg.qbLayout && sticky.dataset.dbQbLayout==='true'){
          var assets=document.querySelector('.db-sticky-qb-assets[data-db-sticky-qb="'+key+'"]');
          if(assets && assets.parentNode!==document.body) document.body.appendChild(assets);

          function openStickyQuickBuy(){
            var popId='db-sticky-qb-'+cfg.sectionId+'-'+cfg.productId+'-popover',drwId='db-sticky-qb-'+cfg.sectionId+'-'+cfg.productId+'-drawer';
            var useDrawer=window.matchMedia('(min-width: 1000px)').matches,targetId=useDrawer?drwId:popId;
            var trigger=(assets||document).querySelector('.db-sticky-qb-trigger[aria-controls="'+targetId+'"]'); if(trigger){trigger.click(); return true;}
            var el=document.getElementById(targetId); if(!el) return false;
            if(typeof el.open==='function'){el.open(); return true;}
            if(typeof el.show==='function'){el.show(); return true;}
            el.setAttribute('open',''); return true;
          }

          var qbBtn=sticky.querySelector('[data-db-sticky-qb-btn]');
          if(qbBtn) qbBtn.addEventListener('click',function(e){e.preventDefault(); openStickyQuickBuy();},{passive:false});

          if(cfg.thumbSync && cfg.thumbSync!=='off'){
            var mapEl=document.getElementById(cfg.mapId),map=[];
            try{map=JSON.parse(mapEl&&mapEl.textContent?mapEl.textContent:'[]')}catch(e){map=[]}
            var byId={}; for(var i=0;i<map.length;i++){var x=map[i]; if(x&&x.id!=null) byId[String(x.id)]=x;}
            var bar=sticky.querySelector('.db-sticky-qbbar'),img=bar?bar.querySelector('.db-sticky-qbbar__img-el'):null,priceEl=bar?bar.querySelector('.db-sticky-qbbar__current'):null;

            function applyVariant(id){
              var v=byId[String(id)]; if(!v) return;
              if(priceEl && v.price!=null) priceEl.textContent=fmt(+v.price);
              if(img && v.img && v.img.src){img.src=v.img.src; if(v.img.srcset) img.srcset=v.img.srcset; if(v.img.alt) img.alt=v.img.alt;}
            }
            function readMainVariantId(){var inp=mainForm.querySelector('input[name="id"]'); return (inp&&inp.value)?String(inp.value):null;}
            function syncFromMain(){var id=readMainVariantId(); if(id) applyVariant(id);}

            on(mainForm,'change',syncFromMain,passive);

            function onVariantChanged(e){
              var t=e.target; if(!t) return;
              var h=t.getAttribute&&t.getAttribute('handle'); if(h && cfg.productHandle && h!==cfg.productHandle) return;
              if(cfg.thumbSync==='main_only'){var qb=t.closest&&t.closest('quick-buy-popover,quick-buy-drawer,.popover--quick-buy,.drawer--quick-buy'); if(qb) return;}
              var d=e.detail||{},vv=d.variant||d,id=vv&&(vv.id||vv.variantId||vv.variant_id); if(id!=null) applyVariant(String(id));
            }
            document.addEventListener('variant:changed',onVariantChanged,true);
            cleanup.push(function(){try{document.removeEventListener('variant:changed',onVariantChanged,true)}catch(e){}});
            syncFromMain();
          }
          return;
        }

        var pv=sticky.querySelector('.product-sticky-form__variants'); if(!pv) return;
        var variantsRaw=[],jsonEl=document.getElementById(cfg.variantsId);
        try{variantsRaw=JSON.parse(jsonEl&&jsonEl.textContent?jsonEl.textContent:'[]')}catch(e){variantsRaw=[]}
        if(!variantsRaw.length) return;

        var stickyImg=null;
        if(cfg.thumbSyncSelect){stickyImg=sticky.querySelector('img.product-sticky-form__image')||sticky.querySelector('.product-sticky-form__image-wrapper img')}
        function vImgSrc(v){var fm=v&&(v.featured_image||(v.featured_media&&(v.featured_media.preview_image||v.featured_media))); return fm&&(fm.src||fm.url)?(fm.src||fm.url):''}
        function setStickyThumb(id){
          if(!stickyImg||id==null) return;
          if(!stickyImg.dataset.dbNoSrcset){stickyImg.removeAttribute('srcset'); stickyImg.removeAttribute('sizes'); stickyImg.dataset.dbNoSrcset='1'}
          id=String(id);
          for(var i=0;i<variantsRaw.length;i++){
            var v=variantsRaw[i];
            if(String(v.id)===id){
              var src=vImgSrc(v);
              if(src) stickyImg.src=src+(src.indexOf('?')>-1?'&':'?')+'width=110';
              break;
            }
          }
        }

        function norm(s){return (s||'').toString().trim().toLowerCase()}
        function isAvail(v){return !!(v&&(v.available===true||v.available===1||v.available==='true'))}

        var optionCount=pv.querySelectorAll('select[name^="sticky_option"]').length||0;
        function getOptsFromVariant(v){var o=[]; if(optionCount>=1) o.push(norm(v.option1)); if(optionCount>=2) o.push(norm(v.option2)); if(optionCount>=3) o.push(norm(v.option3)); return o}
        var variants=new Array(variantsRaw.length);
        for(var i=0;i<variantsRaw.length;i++){var vr=variantsRaw[i]; variants[i]={id:vr.id,price:+vr.price,available:isAvail(vr),opts:getOptsFromVariant(vr)}}

        var byKey={},idxMap=[]; for(i=0;i<optionCount;i++) idxMap[i]={};
        for(i=0;i<variants.length;i++){
          var vv=variants[i],k=vv.opts.join('||'); byKey[k]=vv;
          for(var j=0;j<optionCount;j++){
            var kk=vv.opts[j]||''; (idxMap[j][kk]||(idxMap[j][kk]=[])).push(i);
          }
        }

        function getSelNorm(){var sel=[]; pv.querySelectorAll('select[name^="sticky_option"]').forEach(function(s){sel.push(norm(s.value||''))}); return sel}
        function exactVariant(selNorm){if(!selNorm.length) return null; for(var i=0;i<selNorm.length;i++) if(!selNorm[i]) return null; return byKey[selNorm.join('||')]||null}

        function cand(val,idx,selNorm){
          var key=norm(val),list=idxMap[idx][key]||[],first=null,firstAvail=null;
          for(var k=0;k<list.length;k++){
            var v=variants[list[k]],ok=true;
            for(var j=0;j<selNorm.length;j++){if(j===idx) continue; if(selNorm[j] && selNorm[j]!==v.opts[j]){ok=false; break}}
            if(!ok) continue;
            if(!first) first=v;
            if(v.available){firstAvail=v; break}
          }
          return {v:(firstAvail||first),ok:!!firstAvail,has:!!first};
        }

        function setSubmitState(selNorm){
          var fid=sticky.getAttribute('form-id')||''; if(!fid) return;
          var btn=sticky.querySelector('button[form="'+fid+'"]')||sticky.querySelector('button[type="submit"]'); if(!btn) return;
          var full=true; for(var i=0;i<selNorm.length;i++) if(!selNorm[i]){full=false; break}
          if(!full){btn.disabled=false; btn.setAttribute('aria-disabled','false'); return;}
          var v=exactVariant(selNorm),dis=!v||!v.available;
          btn.disabled=dis; btn.setAttribute('aria-disabled',dis?'true':'false');
        }

        function updateOptionUi(selNorm,show){
          var correctedSelect=null,correctedTo=null;
          pv.querySelectorAll('.select-wrapper').forEach(function(wrap){
            var idx=+wrap.getAttribute('data-option-index')||0;

            if(stickyUseCombo){
              wrap.querySelectorAll('.combo-box__option-item').forEach(function(btn){
                var val=btn.getAttribute('value'),c=cand(val,idx,selNorm);
                btn.disabled=!c.ok; btn.setAttribute('aria-disabled',btn.disabled?'true':'false');
                if(!c.ok && c.has) btn.classList.add('is-disabled'); else btn.classList.remove('is-disabled');
                if(HIDE_SOLD_OUT){
                  var hide=!c.ok;
                  btn.hidden=hide;
                  if(hide){btn.setAttribute('aria-hidden','true'); btn.style.setProperty('display','none','important')}
                  else{btn.removeAttribute('aria-hidden'); btn.style.removeProperty('display')}
                }else{btn.hidden=false; btn.removeAttribute('aria-hidden'); btn.style.removeProperty('display')}
                var priceEl=btn.querySelector('.price-mobile'); if(priceEl) priceEl.textContent=(!mqlDesk.matches&&c.has)?fmt(+c.v.price):'';
              });
            }

            var s=wrap.querySelector('select'); if(!s) return;
            Array.prototype.forEach.call(s.options,function(opt){
              if(!opt.value) return;
              var base=opt.getAttribute('data-label')||opt.value,c=cand(opt.value,idx,selNorm);
              opt.disabled=!c.ok;
              if(HIDE_SOLD_OUT) opt.hidden=!c.ok; else opt.hidden=false;
              var next=show ? ((c.ok&&c.v)?(base+' - '+fmt(+c.v.price)):(base+' - '+UNAVAIL)) : base;
              if(opt.textContent!==next) opt.textContent=next;
            });

            if(HIDE_SOLD_OUT){
              var so=(s.selectedOptions&&s.selectedOptions[0])||null;
              if(!correctedSelect && so && (so.disabled || so.hidden)){
                var fo=Array.prototype.find.call(s.options,function(o){return o.value && !o.disabled && !o.hidden});
                if(fo){correctedSelect=s; correctedTo=fo.value;}
              }
            }
          });

          if(correctedSelect && correctedTo!=null && correctedSelect.value!==correctedTo){
            correctedSelect.value=correctedTo;
            correctedSelect.dispatchEvent(new Event('change',{bubbles:true}));
            return false;
          }
          return true;
        }

        function updateMainPrice(selNorm){
          var lbl=sticky.querySelector('.product-sticky-form__price'); if(!lbl) return;
          var full=true; for(var i=0;i<selNorm.length;i++) if(!selNorm[i]){full=false; break}
          if(HIDE_SEL_PRICE && full && !window.matchMedia('(min-width: 1000px)').matches){lbl.style.display='none'; return;}
          lbl.style.display='';
          var v=full?exactVariant(selNorm):null;
          if(!v){
            for(i=0;i<variants.length;i++){
              var vv=variants[i],ok=true;
              for(var j=0;j<selNorm.length;j++){if(selNorm[j] && selNorm[j]!==vv.opts[j]){ok=false; break}}
              if(ok){v=vv; break}
            }
          }
          if(!v) v=variants[0];
          if(v) lbl.textContent=fmt(+v.price);
        }

        var lock=false,raf=0;
        function runSync(){
          raf=0;
          var selNorm=getSelNorm();
          var ok=updateOptionUi(selNorm, showPrices && !mqlDesk.matches);
          if(ok){updateMainPrice(selNorm); setSubmitState(selNorm);}
        }
        function scheduleSync(){if(raf) return; raf=requestAnimationFrame(runSync);}

        function bindStickyNativeOpenClose(){
          pv.querySelectorAll('.select-wrapper[data-selector-type="native"] select[name^="sticky_option"]').forEach(function(s){
            if(s.dataset.dbPriceBound==='1') return;
            s.dataset.dbPriceBound='1';
            function open(){if(!showPrices){showPrices=true; scheduleSync()}}
            function close(){var v=!HIDE_SEL_PRICE; if(showPrices!==v){showPrices=v; scheduleSync()}}
            s.addEventListener('pointerdown',open,{passive:true,capture:true});
            s.addEventListener('mousedown',open,{passive:true,capture:true});
            s.addEventListener('touchstart',open,{passive:true,capture:true});
            s.addEventListener('focus',open,{passive:true});
            s.addEventListener('keydown',function(e){if(e.key===' '||e.key==='ArrowDown'||e.key==='Enter')open()},{passive:true});
            s.addEventListener('input',open,{passive:true});
            s.addEventListener('blur',close,{passive:true});
            s.addEventListener('change',close,{passive:true});
          });
        }
        bindStickyNativeOpenClose();
                function onBp(){scheduleSync();}
        if(mqlDesk.addEventListener) mqlDesk.addEventListener('change',onBp); else if(mqlDesk.addListener) mqlDesk.addListener(onBp);
        cleanup.push(function(){try{if(mqlDesk.removeEventListener) mqlDesk.removeEventListener('change',onBp); else if(mqlDesk.removeListener) mqlDesk.removeListener(onBp);}catch(e){}});

        if(USE_PH){
          pv.querySelectorAll('.select-wrapper[data-selector-type="native"] .db-sticky-native-select[data-db-ph="1"] select.native-select').forEach(function(s){
            if(s.dataset.dbPhBound==='1') return;
            s.dataset.dbPhBound='1';
            var box=s.closest('.db-sticky-native-select[data-db-ph="1"]'); if(!box) return;
            function show(){box.setAttribute('data-db-ph-hidden','0');}
            function hide(){box.setAttribute('data-db-ph-hidden','1');}
            if(box.getAttribute('data-db-ph-touched')!=='1') show(); else hide();
            s.addEventListener('focus',hide,{passive:true});
            s.addEventListener('pointerdown',hide,{passive:true});
            s.addEventListener('mousedown',hide,{passive:true});
            s.addEventListener('touchstart',hide,{passive:true});
            s.addEventListener('change',function(){box.setAttribute('data-db-ph-touched','1'); hide();},{passive:true});
            s.addEventListener('blur',function(){if(box.getAttribute('data-db-ph-touched')==='1') hide(); else show();},{passive:true});
          });
        }
         
        function setMainOption(pos,value){
          var vStr=String(value||'');
          var r=mainForm.querySelector('input[type="radio"][name="option'+pos+'"][value="'+vStr.replace(/["\\]/g,'\\$&')+'"]');
          if(r){if(!r.checked){r.checked=true; r.dispatchEvent(new Event('change',{bubbles:true}));} return;}
          var s=mainForm.querySelector('select[name="option'+pos+'"]');
          if(s && s.value!==vStr){s.value=vStr; s.dispatchEvent(new Event('change',{bubbles:true}));}
        }
        function setMainVariantId(id){
          var inp=mainForm.querySelector('input[name="id"]'); if(!inp||id==null) return;
          var v=String(id); if(inp.value===v) return;
          inp.value=v;
          try{inp.dispatchEvent(new Event('input',{bubbles:true}))}catch(e){}
          try{inp.dispatchEvent(new Event('change',{bubbles:true}))}catch(e){}
        }
        function ensureMainMatchesSticky(){
          var vMini=exactVariant(getSelNorm());
          if(vMini && vMini.id!=null) setMainVariantId(vMini.id);
        }

        function syncStickyFromVariant(variant){
          if(!variant) return;
          lock=true;
          for(var i=1;i<=optionCount;i++){
            var val=variant['option'+i]||'';
            var sel=pv.querySelector('select[name="sticky_option'+i+'"]');
            if(sel && val && sel.value!==val) sel.value=val;

            var wrap=sel && sel.closest ? sel.closest('.select-wrapper') : null;
            if(wrap && USE_PH){
              var native=wrap.querySelector('.db-sticky-native-select[data-db-ph="1"]');
              if(native){
                if(native.getAttribute('data-db-ph-touched')==='1') native.setAttribute('data-db-ph-hidden', val ? '1' : '0');
                else native.setAttribute('data-db-ph-hidden','0');
              }
            }
         if(sel){
            var bind=sel.getAttribute('data-bind-value');
            if(bind){
              var span=document.getElementById(bind);
              if(span){
                if(USE_PH && stickyUseCombo){
                  var optName=(wrap && (wrap.getAttribute('data-db-opt-name')||''))||'';
                  if(optName) span.textContent=optName;
                }else if(val){
                  span.textContent=val;
                }
              }
            }
          }
          }
          setTimeout(function(){lock=false;},0);
          scheduleSync();
        }

        function readMainVariant(){
          var inp=mainForm.querySelector('input[name="id"]'); if(!inp || !inp.value) return null;
          var id=String(inp.value);
          for(var i=0;i<variantsRaw.length;i++) if(String(variantsRaw[i].id)===id) return variantsRaw[i];
          return null;
        }

        function onMainVariantChanged(e){
          var v=e.detail && e.detail.variant; if(!v) return;
          syncStickyFromVariant(v);
          if(cfg.thumbSyncSelect) setStickyThumb(v.id);
        }
        on(mainForm,'variant:changed',onMainVariantChanged,true);

        function onStickyChange(e){
          if(lock) return;
          var t=e.target; if(!t || t.tagName!=='SELECT') return;
          var m=(t.name||'').match(/^sticky_option(\d+)$/); if(!m) return;
          var pos=parseInt(m[1],10); if(!pos) return;
          if(USE_PH){
            var w=t.closest&&t.closest('.select-wrapper');
            if(w){
              var n=w.querySelector('.db-sticky-native-select[data-db-ph="1"]');
              if(n){n.setAttribute('data-db-ph-touched','1'); n.setAttribute('data-db-ph-hidden','1');}
            }
          }
          lock=true;
          setMainOption(pos,t.value);
          setTimeout(function(){lock=false;},0);
          scheduleSync();
          if(cfg.thumbSyncSelect){
            var vMini=exactVariant(getSelNorm());
            if(vMini && vMini.id!=null) setStickyThumb(vMini.id);
          }
        }
        on(pv,'change',onStickyChange,false);
        (function bindStickySubmit(){
          var btns=sticky.querySelectorAll('button[type="submit"][form="'+cfg.formId+'"],button[form="'+cfg.formId+'"][type="submit"]');
          if(!btns||!btns.length) return;
          btns.forEach(function(btn){
            if(btn.dataset.dbSubmitBound==='1') return;
            btn.dataset.dbSubmitBound='1';
            function pre(){if(lock) return; ensureMainMatchesSticky();}
            btn.addEventListener('pointerdown',pre,{passive:true,capture:true});
            btn.addEventListener('mousedown',pre,{passive:true,capture:true});
            btn.addEventListener('touchstart',pre,{passive:true,capture:true});
            btn.addEventListener('click',pre,{passive:true,capture:true});
          });
          if(mainForm && mainForm.dataset.dbStickySubmitBound!=='1'){
            mainForm.dataset.dbStickySubmitBound='1';
            mainForm.addEventListener('submit',function(){ensureMainMatchesSticky();},true);
          }
        })();

        scheduleSync();
        var iv=readMainVariant(); if(iv){syncStickyFromVariant(iv); if(cfg.thumbSyncSelect) setStickyThumb(iv.id)}
      }

      setupVisibility();
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initAll,{once:true});
  else initAll();
})();